import React, { useState, useEffect } from "react";
import {
  List,
  Filter,
  CrudForm,
  RichText,
  useParentChildrenNavigation,
  CrudTabs,
  CrudRoute,
  ListApi,
  FormApi,
  loopback,
} from "elentari";
import * as R from "ramda";
import Grid from "@material-ui/core/Grid";
import { TextField, Checkbox } from "final-form-material-ui";
import { Field } from "react-final-form";
import {
  receitaApi,
  grupoAlimentarApi,
  receitaGrupoAlimentarApi,
} from "../../services/Api";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";

const { loopbackFilters } = loopback;

const ReceitaFilter = () => (
  <Filter labels={{ find: "Buscar", clear: "Limpar" }}>
    <Grid spacing={24} container>
      <Grid item xs>
        <Field
          fullWidth
          component={TextField}
          label="Título Interno"
          name="tituloInterno"
        />
      </Grid>
    </Grid>
  </Filter>
);

const listOptions = {
  defaultOrder: "tituloInterno",
  fields: {
    tituloInterno: {
      label: "Título Interno",
    },
    titulo: {
      label: "Título",
    },
  },
};

export const ReceitasList = (props) => (
  <ListApi
    filtersConfig={{
      tituloInterno: loopbackFilters.regexp,
    }}
    api={receitaApi}
  >
    {({ getPage, handleDelete, getCount }) => (
      <div>
        <ReceitaFilter />
        <List
          {...props}
          withPaper
          getCount={getCount}
          deleteItem={handleDelete}
          onClickEdit={(item) => props.history.push(`/receitas/${item.id}`)}
          onClickNew={() => props.history.push("/receitas/new")}
          getPage={getPage}
          listOptions={listOptions}
        />
      </div>
    )}
  </ListApi>
);

export function ReceitasForm(props) {
  const validate = (values) => ({
    tituloInterno: values.tituloInterno ? undefined : "Obrigatório",
    titulo: values.titulo ? undefined : "Obrigatório",
    alimentos:
      values.alimentos === undefined || values.alimentos === "<p><br></p>"
        ? "Obrigatório"
        : undefined,
  });
  return (
    <FormApi api={receitaApi} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item sm>
                  <Field
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Título Interno"
                    name="tituloInterno"
                  />
                </Grid>
                <Grid item sm>
                  <Field
                    fullWidth
                    component={TextField}
                    label="Título da Receita"
                    name="titulo"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Field component={RichText} name="alimentos" label="Alimentos" />
            </Grid>
            <Grid item>
              <Field component={RichText} name="medidas" label="Medidas" />
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}

function GruposAlimentaresTabList(props) {
  const [gruposAlimentares, setGruposAlimentares] = useState([]);

  const fetchGruposAlimentares = async () => {
    const response = await grupoAlimentarApi.getList();
    if (response.ok) {
      setGruposAlimentares(response.data);
    }
  };
  const getItems = async () => {
    const { params } = props.match;
    const response = await receitaGrupoAlimentarApi.getList({
      where: { receitaId: params.id },
    });
    if (response.ok) {
      const { data } = response;
      return {
        grupoAlimentar: data.map(R.prop("grupoAlimentarId")),
      };
    }
  };
  const handleSubmit = async (data) => {
    const { params } = props.match;
    const receitaGrupoAlimentarResponse =
      await receitaGrupoAlimentarApi.getList({
        where: { receitaId: params.id },
      });
    if (receitaGrupoAlimentarResponse.ok) {
      await Promise.all(
        receitaGrupoAlimentarResponse.data.map((obj) =>
          receitaGrupoAlimentarApi.deleteF(obj.id)
        )
      );
    }
    const promises = data.grupoAlimentar.map((grupoId) =>
      receitaGrupoAlimentarApi.create({
        receitaId: Number(params.id),
        grupoAlimentarId: Number(grupoId),
      })
    );
    const responses = await Promise.all(promises);
    if (R.all(R.prop("ok"))(responses)) {
      return {
        ok: true,
      };
    }
    return { ok: false };
  };

  useEffect(() => {
    fetchGruposAlimentares();
  }, []);

  return (
    <CrudForm
      history={props.history}
      getItem={getItems}
      onSubmit={handleSubmit}
    >
      <FormControl component="fieldset" style={{ width: "100%" }}>
        <FormGroup row>
          <Grid container style={{ width: "100%" }}>
            {gruposAlimentares.map((item) => (
              <Grid item sm={4} key={item.descricao}>
                <FormControlLabel
                  label={item.descricao}
                  control={
                    <Field
                      color="primary"
                      name="grupoAlimentar"
                      value={item.id}
                      type="checkbox"
                      component={Checkbox}
                    />
                  }
                />
              </Grid>
            ))}
          </Grid>
        </FormGroup>
      </FormControl>
    </CrudForm>
  );
}

export function ReceitasTabs(props) {
  const { current, navigate } = useParentChildrenNavigation(props, {
    mainPath: "receitas",
    availableTabs: ["grupos-alimentares"],
  });
  return (
    <CrudTabs
      {...props}
      mainPath="receitas"
      current={current}
      tabs={[
        { value: "", label: "Receita" },
        { value: "grupos-alimentares", label: "Grupos Alimentares" },
      ]}
      navigate={navigate}
    >
      <div>
        <CrudRoute render={() => <ReceitasForm {...props} />} />
        <CrudRoute
          name="grupos-alimentares"
          render={() => (
            <GruposAlimentaresTabList
              {...props}
              onClickNew={navigate("newChild")}
            />
          )}
        />
      </div>
    </CrudTabs>
  );
}
